import React from 'react';
import { Link } from 'react-router-dom';

export default function IconBoxStyle9({ title, iconUrl, href, index }) {
  return (
    <>
      <style>
        {`
          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-15px);
            }
          }
        `}
      </style>
      <Link
        href={href}
        className="cs_iconbox cs_style_9 text-center cs_radius_20"
        style={{
          height: '100%',
          minHeight: '200px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '30px 20px',
          animation: `bounce 2s ease-in-out infinite`,
          animationDelay: `${(index || 0) * 0.2}s`
        }}
      >
        <img src={iconUrl} alt="Icon" style={{ marginBottom: '15px' }} />
        <h2 className="cs_iconbox_title cs_white_color cs_fs_20 cs_medium mb-0" style={{ textAlign: 'center' }}>
          {title}
        </h2>
      </Link>
    </>
  );
}
